function AddProductsToCart(productsArr, $this){
  $this.addClass("active");
  let formData = {
    'items': productsArr,
    sections: "cart-drawer,cart-icon-bubble"
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(res => {
    if (AMP_API) {
      AMP_API.OPEN_CART();
    } else {
      const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
      const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      $("cart-drawer.drawer").removeClass("is-empty"); $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
      $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
      document.querySelector("#cart-icon-bubble").dispatchEvent(new Event('click'));
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(() => {
    $this.removeClass("active");
  });
}

$(document).on("click", ".custom-product-grid-btn, .custom-iwt-2-atc-btn, .custom-hero-atc-btn", function(e){
  let arr = [];
  arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
  AddProductsToCart(arr, $(this));
})

$(document).on("click", ".custom-sticky-btn", function(){
  let arr = [];
  arr.push({ 'id': $('.custom-product-form input[name="id"]').attr("value"), 'quantity': 1 });
  AddProductsToCart(arr, $(this));
})

$(document).on("click", ".custom-footer-li-heading", function(){
  $(this).toggleClass("active");
  $(this).next(".custom-footer-ul-drop").slideToggle(250);
})

$(document).click(function(){
  $(".custom-hotspot-inp").prop("checked", false);
})
$(document).on("click", ".custom-hotspot-label, .custom-hotspot-inp", function(e){
  e.stopPropagation();
})

$(function(){
  function setCustomHeaderOffset(){
  let offset = 0;
  let announcement = document.querySelector('.custom-ann');
  let header = document.querySelector('.header-wrapper');

  if (announcement) offset += announcement.offsetHeight;
  if (header) offset += header.offsetHeight;

  document.documentElement.style.setProperty('--custom-drawer-offset', offset + 'px');
}

$(window).on('load resize', setCustomHeaderOffset);
  if($(".custom-sticky-wrapper").length > 0){
    let mainProduct = $(".custom-main-product");
    let offset = mainProduct.offset().top + mainProduct.outerHeight();
    $(document).scroll(function() {
      var y = $(this).scrollTop();
      if (y > offset) {
        $(".custom-sticky-wrapper").addClass("active");
      } else {
        $(".custom-sticky-wrapper").removeClass("active");
      }
    });
    $(".custom-sticky-nav-li, .custom-main-product-read-more-scroll-btn").click(function(e){
      e.preventDefault();
      let title = $(this).attr("data-title").trim();
      let $this = $(this);
      $(".custom-target-section").each(function(){
        let target = $(this).attr("data-target").trim();
        if(title == target){
          $(".custom-sticky-nav-li").removeClass("active");
          $this.addClass("active");
          let top = $(this).offset().top;
          $('html, body').animate({
            scrollTop: top
          }, 500);
        }
      })
    })
  }
});

$(".custom-header-drawer-drop").click(function(e){
  e.preventDefault();
  $(this).toggleClass("active");
  $(this).parent().find(".custom-header-drawer-ul-1").slideToggle(300);
})

$(".custom-header-drawer-slide").click(function(e){
  e.preventDefault();
  $(this).parent().find(".custom-header-drawer-ul-2-wrapper").addClass("active");
  $(".custom-header-drawer").addClass("custom-drawer-oh");
})

$(".custom-header-drawer-back").click(function(){
  $(".custom-header-drawer-ul-2-wrapper").removeClass("active");
  $(".custom-header-drawer").removeClass("custom-drawer-oh");
})
$(".header__icon--hamburger").click(function(e){
  e.preventDefault();
  $(this).toggleClass("active");
  $(".custom-header-drawer").toggleClass("active");
  $(".custom-header-drawer-overlay").fadeToggle(300);
})

$(".custom-header-drawer-close, .custom-header-drawer-overlay").click(function(){
  $(".header__icon--hamburger").removeClass("active");
  $(".custom-header-drawer").removeClass("active");
  $(".custom-header-drawer-overlay").fadeOut(300);
})

$(".custom-acc-title").click(function(){
  $(this).toggleClass("active");
  $(this).next(".custom-acc-text").slideToggle(300);
})

